<template>
    <Overlay :show="showOverlay">
        <ProductCategorySelect
            :selected-items="selected"
            :title="title"
            :hide-hierarchy-column="true"
            :show-instruction="false"
            :border="true"
            :border-variant="borderVariant"
            @change="onCategoryChange"
        >
            <template #sub-title>
                <div v-if="parentTitle">
                    <b-icon-folder/>
                    <span class="text-less-muted" style="font-size: 0.9rem; padding-left: 4px;">{{ parentTitle }}</span>
                </div>
            </template>
        </ProductCategorySelect>
    </Overlay>
</template>

<script>
import {Button} from "@core/components/common";
import ProductCategoryTagView from "@core/components/product/ProductCategoryTagView";
import {BCard, BListGroup, BListGroupItem, BIconFolder} from 'bootstrap-vue'
import {ProductType} from "@/libs/product";
import Overlay from "@core/components/common/Overlay";
import {ProductCategorySelect} from "@core/components/product";

export default {
    components: {BCard, ProductCategoryTagView, BListGroup, BListGroupItem, Button, Overlay, ProductCategorySelect,
        BIconFolder},
    props: {
        product: {
            required: true
        },
        categories: {
            default() {
                return [];
            }
        },
        title: {
            default: ''
        },
        parentTitle: {

        }
    },
    data() {
        return {
            selected: this.categories,
            showOverlay: false
        };
    },
    methods: {
        categoryModalClosed() {
            this.emit();
            this.emitValidity();
        },
        afterCategoryRemoved(categories) {
            this.selected = categories;
        },
        onCategoryChange({idList, items}) {
            this.selected = items.map(item => item.category);
            this.categoryModalClosed();
        },
        emit() {
            this.$emit('change', this.selected, this.product, () => {
                this.showOverlay = true
            }, () => this.showOverlay = false);
        },
        emitValidity() {
            this.$emit('validityChanged', this.selected.length > 0);
        }
    },
    computed: {
        taricCodesLabel() {
            return (this.product.type === ProductType.PURCHASED || this.product.type === ProductType.PURCHASED_UNDEFINED_SUPPLIER)
                ? this.$t('Page(ReceivedRequest):Component(TaricCodes):label-purchased')
                : this.$t('Page(ReceivedRequest):Component(TaricCodes):label-own');
        },
        borderVariant() {
            return this.categories.length > 0 ? 'success' : 'light';
        }
    },
    watch: {
        categories() {
            this.selected = this.categories;
        }
    }
}
</script>
